<template>
  <div class="col-sm-11">
    <div class="row">
      <ArtworkImage :artwork="artwork"/>
      <div v-html="artwork.catalogNumber" class="headings--h2 artwork-number d-none"></div>
      <div class="col details__desc pt-0">
        <ArtworkHeader
          :artwork="artwork"
          :index="index"
        />
        <h4 v-if="artwork.date"> {{ I18n.l("date.formats.time", artwork.date) }} </h4>
        <div class="row details__art-desc">
          <div class="col-12 col-lg-8">
            <h4
              v-if="artwork.artist"
              class="text--muted"
            >
              {{ artwork.name }}
            </h4>
            <p
              v-if="artwork.description"
              v-html="artwork.description.substring(0, 230)"
              class="text--muted"
            >
            </p>
          </div>
        </div>
        <div
          v-if="haveSaleDetailsProvided"
          class="row details__actions align-items-end"
        >
          <div class="col-12 col-lg-4 col-xl-3">
            <p class="headings--h4">{{ I18n.t("artworks.starting_price_label")}}</p>
            <p v-if="artwork.startingPrice > 0"> {{ I18n.t("artworks.price", { price: formatPrice(artwork.startingPrice) }) }} </p>
            <p v-else>
              <span class="price--info" v-b-tooltip.hover.bottomright :title="I18n.t('artworks.no_starting_price_info')"></span>
            </p>
          </div>
          <div
            v-if="artwork.estimationMin && artwork.estimationMax"
            class="col-12 col-lg-4"
          >
            <p class="headings--h4">
              {{ I18n.t("artworks.estimation_label") }}
            </p>
            <p>
              {{ I18n.t("artworks.estimated_prices_with_currency",
              { price_min: formatPrice(artwork.estimationMin),
                price_max: formatPrice(artwork.estimationMax) }) }}
            </p>
          </div>
          <ArtworkState :artwork="artwork"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import ArtworkImage from './artwork_image';
  import ArtworkHeader from './artwork_header';
  import ArtworkState from './artwork_state';
  import { LIVE_TYPE } from '../../consts';

  export default {
    name: 'ArtworkDetails',
    components: {
      ArtworkHeader,
      ArtworkState,
      ArtworkImage,
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['auctionsCatalog']),
      haveSaleDetailsProvided() {
        return Object.prototype.hasOwnProperty.call(this.artwork, 'startingPrice') ||
          Object.prototype.hasOwnProperty.call(this.artwork, 'estimationMin') ||
          Object.prototype.hasOwnProperty.call(this.artwork, 'estimationMax');
      },
    },
    created() {
      this.formatPrice = formatNumber;
      this.LIVE_TYPE = LIVE_TYPE;
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/artwork/artwork_details.vue?4afa2d1c